"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_view_drive_controller_1 = __importDefault(require("./instructor-view-drive.controller"));
var instructor_view_drive_html_1 = __importDefault(require("./instructor-view-drive.html"));
var json_1 = require("../../../common/helpers/json");
function getPolicy(PoliciesModel) {
    return PoliciesModel.getByID('drives').then(function (data) {
        var policy = data.policy;
        var policyMeta = {};
        policy.policymeta.forEach(function (meta) {
            policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value) ? JSON.parse(meta.meta_value) : meta.meta_value;
        });
        policy.policymeta = policyMeta;
        policy.policymeta.id = policy.id;
        /*
        let response = {
            'AdhocPickupLocationPolicyData': {
                id: 0,
                FeatureEnabled : false,
            },
            'UseReportCards': {
                id: 0,
                FeatureEnabled : false,
            },
            'UseServiceArea': {
                id: 0,
                FeatureEnabled : false,
            },
            'StudentsCanBook' : {
                id: 0,
                FeatureEnabled : false,
            },
            'AllowGradeDuringDrive' : {
                id: 0,
                FeatureEnabled : false,
            },
            'AllowInstructorsToCancel' : {
                id: 0,
                FeatureEnabled : false,
            },
            'InstructorCanBookDrivingLessons' : {
                id: 0,
                FeatureEnabled : false,
            },
            'InstructorCanViewStudentOrders' : {
                id: 0,
                FeatureEnabled : false,
            }
        };
        */
        var response = {};
        if (!policyMeta.hasOwnProperty('allow_adhoc_pickup_locations')) {
            response.AdhocPickupLocationPolicyData = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        else {
            response.AdhocPickupLocationPolicyData = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.allow_adhoc_pickup_locations === 'Y'
            };
        }
        if (!policyMeta.hasOwnProperty('use_report_cards')) {
            response.UseReportCards = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        else {
            response.UseReportCards = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.use_report_cards === 'Y'
            };
        }
        if (!policyMeta.hasOwnProperty('use_service_area')) {
            response.UseServiceArea = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        else {
            response.UseServiceArea = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.use_service_area === 'Y'
            };
        }
        if (!policyMeta.hasOwnProperty('allow_students_to_schedule')) {
            response.StudentsCanBook = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        else {
            response.StudentsCanBook = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.allow_students_to_schedule === true
            };
        }
        if (!policyMeta.hasOwnProperty('allowGradeDuringDrive')) {
            response.AllowGradeDuringDrive = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        else {
            response.AllowGradeDuringDrive = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.allowGradeDuringDrive === 'Y'
            };
        }
        if (policyMeta.hasOwnProperty('instructor_can_view_student_orders')) {
            response.InstructorCanViewStudentOrders = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.instructor_can_view_student_orders === 'Y'
            };
        }
        else {
            response.InstructorCanViewStudentOrders = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        if (policyMeta.hasOwnProperty('instructor_can_book_driving_lessons')) {
            response.InstructorCanBookDrivingLessons = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.instructor_can_book_driving_lessons === 'Y'
            };
        }
        else {
            response.InstructorCanBookDrivingLessons = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        if (policyMeta.hasOwnProperty('allow_instructors_to_cancel')) {
            response.AllowInstructorsToCancel = {
                'id': policy.id,
                'FeatureEnabled': policyMeta.allow_instructors_to_cancel === 'Y'
            };
        }
        else {
            response.AllowInstructorsToCancel = {
                'id': policy.id,
                'FeatureEnabled': false
            };
        }
        return response;
    }).catch(function (Error) {
        console.error(Error);
    });
}
getPolicy.$inject = ['PoliciesModel'];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.instructor.dashboard.drive', {
        'url': '/drive/:driveId',
        'controller': 'InstructorDriveController',
        'controllerAs': 'vm',
        'template': instructor_view_drive_html_1.default,
        'resolve': {
            policyData: getPolicy,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default.module('instructor.dashboard.drive', [])
    .config(config)
    .controller('InstructorDriveController', instructor_view_drive_controller_1.default);
